import {
  Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges,
} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {FontAwesomeService} from 'app/services/font-awesome.service';
import {Option} from "app/model/select-dropdown-option.interface";

@Component({
  selector: 'app-select-field',
  template: `
    <ng-container [formGroup]="parent">
      <span
        *ngIf="country && selected"
        class="selected-flag flag-{{selected?.toLowerCase()}}"
        [ngClass]="label ? 'flag-small' : 'flag'"></span>
      <fa-icon *ngIf="leadingIcon"
               class="leading-icon"
               [icon]="faService[leadingIcon]"></fa-icon>
      <mat-select
        #matSelect
        (selectionChange)="handleSelect($event);"
        [(value)]="selected"
        [ngClass]="classes"
        animateSelect
        [label]="labelRef"
        [leadingIcon]="leadingIcon"
        [error]="error"
        [selectValue]="parent.get(controlName).value"
        [disabled]="disabled">
        <!--[ngStyle]="{paddingLeft: leadingIcon ? '34px': ''}"-->
        <mat-option *ngFor="let option of options" [value]="option.value">
          <span
            *ngIf="country"
            class="flag-{{option?.value.toLowerCase()}}"
            [ngClass]="label ? 'flag-small' : 'flag'"></span>
          {{option.label}}
        </mat-option>
      </mat-select>
      <input *ngIf="countryControlName" hidden [formControlName]="countryControlName">
      <label #labelRef
        (click)="handleClick();matSelect.open()"
        [ngClass]="classes">{{label}}</label>
      <fa-icon 
        class="trailing-icon" 
        [icon]="faService.faChevronDown" 
        (click)="matSelect.toggle()"></fa-icon>
      <validation-error
        [showError]="error"
        [errors]="parent.get(this.controlName)?.errors"
        [name]="label">
      </validation-error>
    </ng-container>
  `,
  styleUrls: ['../common.scss', './select-field.component.scss', './country-select.component.scss'],
})

export class SelectFieldComponent implements OnInit, OnChanges {
  error = false;
  selected: string;

  @Input() label: string;
  @Input() parent: FormGroup;
  @Input() controlName: string;
  @Input() country: boolean;
  @Input() countryControlName: string;
  @Input() submitted: boolean;
  @Input() options: Array<Option>;
  @Input() leadingIcon: string;
  @Input() isReseting: string;
  @Input() selectedValue: string;
  @Input() errorSource: FormGroup | FormControl;

  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() valueChanges: EventEmitter<any> = new EventEmitter();

  constructor(public faService: FontAwesomeService) {}

  handleClick() {
  }
  ngOnInit() {
    this.selected = this.parent.get(this.controlName).value;
    this.parent.get(this.controlName).valueChanges
      .subscribe(value => this.handleValueChange(value));

    const errorSource = this.errorSource || this.parent.get(this.controlName);
    errorSource.statusChanges
      .subscribe(status => {
        this.error = status === 'INVALID';
      });
  }


  get disabled() {
    return this.parent.get(this.controlName).disabled;
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes.parent) {
      this.selected = this.parent.get(this.controlName).value;
    }
    if (changes.submitted && changes.submitted.currentValue && ((this.errorSource || this.parent.get(this.controlName)).invalid)) {
      this.error = true;
    }
    if(changes.isReseting && changes.isReseting.currentValue) {
      this.error = false;
    }
    if (changes.selectedValue && changes.selectedValue.currentValue !== changes.selectedValue.previousValue) {
      this.handleValueChange(changes.selectedValue.currentValue);
    }
  }


  handleSelect(event) {
    const selectedOption = this.options.find(opt => opt.value === event.value);
    this.change.emit(selectedOption);
    this.selected = event.value;
    this.parent.get(this.controlName).setValue(this.selected || null);
  }

  get classes() {
    let classes = '';
    if (this.country) {
      classes += 'country-select ';
    }
    if (this.leadingIcon) {
      classes += 'leading-icon ';
    }
    if (this.disabled) {
      classes += 'disabled '
    }
    return classes;
  }

  handleValueChange(value) {
    this.selected = value;
    const option: Option = this.options && this.options.find(opt => opt.value === value);
    if (option && this.countryControlName) {
      this.parent.get(this.countryControlName).setValue(option.label);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/form-fields/select-field/select-field.component.ts